import { Config } from "../config/config";

//centralized fetch
async function request(path, { method = "GET", params, signal } = {}) {
  const url = new URL(`${Config.ApiBaseUrl}${path}`);

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        url.searchParams.set(key, value);
      }
    });
  }

  const response = await fetch(url.toString(), {
    method,
    signal,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${Config.Token}`,
    },
  });

  if (!response.ok) {
    let message = `Request to ${path} failed with status ${response.status}`;
    try {
      const errorBody = await response.json();
      message = errorBody?.detail || errorBody?.message || message;
    } catch {
      // Response body wasn't JSON (e.g. HTML error page) - keep default message.
    }
    throw new Error(message);
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
}

export const apiClient = {
  get: (path, options) => request(path, { ...options, method: "GET" }),
};
